import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||52}
    height={undefined}
    viewBox="0 0 52 43"
    style={{aspectRatio:52/43}}
    fill="none"
    {...props}
  >
    <g opacity={0.7}>
      <path
        fill="#00E9BA"
        d="m31.55 42.189-6.9-6.896H4.013a3.975 3.975 0 0 1-3.971-3.97V15.608c0-2.19 1.781-3.97 3.97-3.97h14.19v3.403H4.013a.567.567 0 0 0-.567.567v15.715c0 .313.254.567.568.567H26.06l2.085 2.085v-7.453h3.403v15.667Z"
      />
      <path
        fill="#FF6E58"
        d="M20.783 30.819V4.236c0-2.19 1.781-3.97 3.97-3.97h22.572c2.19 0 3.97 1.78 3.97 3.97v15.715c0 2.19-1.78 3.97-3.97 3.97H27.683l-6.9 6.9v-.002Zm3.97-27.15a.567.567 0 0 0-.566.567v18.367l2.085-2.085h21.05a.567.567 0 0 0 .568-.567V4.236a.567.567 0 0 0-.567-.567h-22.57Z"
      />
      <path
        fill="#FF6E58"
        d="M35.423 14.351a3.1 3.1 0 0 1 .44-1.617c.295-.49.697-.874 1.207-1.153.252-.134.452-.331.597-.592.145-.261.218-.55.218-.862 0-.314-.073-.572-.22-.817a1.633 1.633 0 0 0-1.405-.794c-.292 0-.571.07-.819.213a1.586 1.586 0 0 0-.805 1.398h-1.888c0-.645.157-1.232.472-1.761.315-.529.74-.95 1.273-1.266a3.409 3.409 0 0 1 1.767-.472 3.4 3.4 0 0 1 1.766.472c.53.315.955.737 1.272 1.266.318.529.477 1.116.477 1.76a3.63 3.63 0 0 1-.483 1.827 3.353 3.353 0 0 1-1.328 1.293c-.202.11-.36.261-.476.456a1.255 1.255 0 0 0-.175.652h-1.888l-.002-.003Zm1.014 3.513a.933.933 0 0 1-.692-.286.952.952 0 0 1-.281-.697c0-.274.093-.494.281-.68a.948.948 0 0 1 .692-.28c.273 0 .495.093.681.28a.926.926 0 0 1 .279.68.97.97 0 0 1-.279.697.915.915 0 0 1-.68.286Z"
      />
      <path
        fill="#3F538D"
        d="M10.796 21.741a1.454 1.454 0 1 0 0 2.909 1.454 1.454 0 0 0 0-2.909ZM16.763 21.741a1.454 1.454 0 1 0 0 2.909 1.454 1.454 0 0 0 0-2.909Z"
      />
    </g>
  </svg>
)
export default SvgComponent
